exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html[dir] ._3pp1Qufz2t7toh0C6btOdR{margin-bottom:20px}._1ebMuzYXLa7vqjY032dKYy{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._1ebMuzYXLa7vqjY032dKYy{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"renameFolders": "_3pp1Qufz2t7toh0C6btOdR",
	"reloadButton": "_1ebMuzYXLa7vqjY032dKYy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/config/general/owa-regional-option/lib/view/Regional.scss
// module id = 4937
// module chunks = 2